import { CoreService } from './Providers/core.service';
import { ServiceAdminService } from './Providers/service-admin.service';
import { RoutingModuleModule } from './routing-module.module';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { HttpModule } from '@angular/http';
import { BrowserModule } from '@angular/platform-browser';
import { AppComponent } from './app.component';
import { AuthentificationComponent } from './authentification/authentification.component';
import { AdminComponentComponent } from './admin-component/admin-component.component';
import { CompteDetailsComponent } from './admin-component/compte-details/compte-details.component';
import { AdminComponentModule } from './admin-component/admin-component.module';
import { ErrorComponent } from './error/error.component';
import {ToastOptions,ToastModule} from 'ng2-toastr';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { CustomOption } from './utils/custom';

/**
 * 
 *  created by AHMED HAYEL 
 *
 */

@NgModule({
  declarations: [
    AppComponent,
    AuthentificationComponent,
    ErrorComponent
  ],
  imports: [
    FormsModule,
    HttpModule,
    RoutingModuleModule,
    AdminComponentModule,
    BrowserModule,
    BrowserAnimationsModule,
    ToastModule.forRoot()
  ],
  providers: [ServiceAdminService,{provide: ToastOptions, useClass: CustomOption}, CoreService],
  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/app.module.ts